import {useMemo} from 'react';

import {WorkspaceTemplate} from '../../../graphql/workspaceTemplates';
import {LinePlotSettings} from '../../WorkspaceDrawer/Settings/types';
import {
  LINE_PLOT_TEMPLATE_DISPLAY_FNS,
  LINE_PLOT_TEMPLATE_FIELDS,
} from './linePlotTemplateFields';

/**
 * This hook is used in both the template drawer and the user settings page.
 * In both pages, we want to display the same data; however, the template
 * drawer needs to handle strikethrough old values when relevant.
 */
export const useTemplateSections = ({
  workspaceTemplate,
  currWorkspaceLinePlotSettings,
}: {
  workspaceTemplate: WorkspaceTemplate;
  currWorkspaceLinePlotSettings?: LinePlotSettings;
}) => {
  const linePlotTemplateSections = useLinePlotTemplateSections({
    currTemplateLinePlotSettings: workspaceTemplate?.linePlotSettings,
    currWorkspaceLinePlotSettings,
  });

  return [...linePlotTemplateSections];
};

const useLinePlotTemplateSections = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: {
  currTemplateLinePlotSettings: WorkspaceTemplate['linePlotSettings'];
  currWorkspaceLinePlotSettings?: LinePlotSettings;
}) => {
  return useMemo(() => {
    return [
      {
        title: 'Data',
        rows: LINE_PLOT_TEMPLATE_FIELDS.map(key => {
          return LINE_PLOT_TEMPLATE_DISPLAY_FNS[key](
            currTemplateLinePlotSettings,
            currWorkspaceLinePlotSettings
          );
        }),
      },
    ];
  }, [currTemplateLinePlotSettings, currWorkspaceLinePlotSettings]);
};
